import { createContext } from 'react';

const UniqueIdFactoryContext = /*#__PURE__*/createContext(undefined);

export { UniqueIdFactoryContext };
